<template>
  <div class="flex flex-col items-center justify-center min-h-screen bg-gray-100">
    <div class="w-full max-w-sm mb-4">
      <svg id="Livello_1" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 468.2 112">
        <rect y="0" width="468.2" height="112" style="fill: none" />
        <path
          d="M111.9,55.5C111.8,24.9,87,.1,56.4,0,25.6-.1.6,24.7.4,55.5c-.1,30.8,24.7,55.8,55.5,56,11.5,0,22.1-3.4,31-9.3,1-10.2-.7-20.6-6.9-29.3-1.4-2-3.1-3.8-4.9-5.5-3.9,6.4-9.6,11.6-16.4,14.8-7.9,3.5-15.8,2.6-21.5-2.5-4-3.3-5.6-8.7-4.2-13.7,2-7.3,9.5-14,17.4-15.5h.1c6-1.2,12.3-.8,18.1,1.1-.2-4.4-2.6-8.4-6.5-10.5-4.6-2.8-10.5-2.6-14.9.5l-6-9c7.9-5.4,18.3-5.7,26.5-.8,7.9,4.6,12.5,13.5,11.7,22.6,0,.9-.1,1.8-.2,2.6,3.8,2.7,7,6.1,9.7,9.9h0c5.3,7.7,8.4,16.7,9,26.1,8.6-9.8,13.9-22.6,14-36.7v-.5Z"
          style="fill: #e95f2d" />
        <path
          d="M52.7,61c-3.8.8-8.1,4.5-9,7.7-.4,1,0,2.1.9,2.8,2.6,2.3,5.9,2.5,10,.7h0c4.7-2.3,8.6-5.8,11.3-10.3-4.2-1.4-8.8-1.7-13.1-.9Z"
          style="fill: #e95f2d" />
        <polygon
          points="162.1 37.3 162.1 52 190.2 52 190.2 61.7 162.1 61.6 162.1 84.8 146.2 84.8 146.2 27.2 192.7 27.2 192.7 37.3 162.1 37.3 162.1 37.3"
          style="fill: #232323" />
        <path
          d="M228.5,86.2c-9.8,0-17.4-2.5-22.9-7.4-5.4-4.9-8.1-11.9-8.1-20.8v-30.8h15.6v29.8c0,5.7,1.3,10.1,4,13.1,2.7,3,6.5,4.6,11.5,4.6s8.6-1.5,11.3-4.5,4-7.2,4-12.8v-30.2h15.6v30.4c0,9.1-2.7,16.1-8.1,21.1s-13,7.5-22.8,7.5"
          style="fill: #232323" />
        <polygon points="310.4 73.9 310.4 84.8 267.6 84.8 267.6 27.2 283.3 27.2 283.3 74 310.4 73.9"
          style="fill: #232323" />
        <path
          d="M346.9,86.4c-6.5.1-12.9-1.2-18.9-3.8-5.3-2.3-9.8-6-13-10.7-6.2-9.7-6.2-22.2,0-31.9,3.3-4.7,7.8-8.4,13-10.7,6-2.6,12.4-3.9,19-3.8,6.1,0,12.1,1,17.8,3.1,4.8,1.8,9.1,4.8,12.3,8.8,3,3.7,4.6,8.3,4.8,13l-15.9.5c-.2-4.3-2.3-8.3-5.7-11-3.5-2.8-7.9-4.2-13.4-4.2-3.6,0-7.2.8-10.4,2.5-3,1.6-5.5,4.1-7.2,7.1-1.8,3.2-2.7,6.8-2.6,10.5,0,3.6.8,7.2,2.6,10.4,1.7,3,4.2,5.4,7.2,7,3.2,1.7,6.8,2.5,10.4,2.5,4.8.2,9.5-1.3,13.4-4.1,3.5-2.6,5.6-6.6,6-10.8l15.8.3c-.2,4.8-1.9,9.4-4.9,13.2-3.3,4-7.5,7.1-12.4,8.9-5.7,2.2-11.7,3.3-17.8,3.2h0Z"
          style="fill: #232323" />
        <path
          d="M444.3,73.3c-.9-4.4-3.3-8.4-6.8-11.3-3.3-2.6-7.8-3.9-13.8-3.9h-1.2v-.5h3.2c5.6,0,10.1-1.3,13.4-3.8,3.2-2.4,5-6.1,4.9-10.1,0-3.2-1.1-6.3-3.2-8.8-2.5-2.7-5.7-4.7-9.2-5.8-4.5-1.4-9.3-2.1-14-2h0s-29,0-29,0v57.5h15.9v-20.3h8.5c3.1-.1,6.1.7,8.7,2.3,2.4,1.7,4.1,4.3,4.7,7.3l2.1,10.7h18.2l-2.5-11.4ZM416.4,55.9h-11.8v-19.2h11.7c3.1-.2,6.1.8,8.6,2.6.3.2.5.5.8.8,3.5,3.9,3.1,9.8-.7,13.3-2.4,1.9-5.4,2.8-8.5,2.6Z"
          style="fill: #232323" />
        <rect x="452.6" y="27.2" width="15.6" height="57.5" style="fill: #232323" />
      </svg>
    </div>
    <div class="bg-white p-8 rounded shadow-md w-full max-w-sm">
      <form @submit.prevent="handleLogin">
        <div class="mb-4">
          <label class="block text-gray-700 mb-2" for="username">Username</label>
          <input v-model="username" id="username" type="text" autocomplete="username"
            class="w-full px-3 py-2 border rounded" required />
        </div>
        <div class="mb-4">
          <label class="block text-gray-700 mb-2" for="password">Password</label>
          <div class="relative">
            <input v-model="password" id="password" :type="showPassword ? 'text' : 'password'" autocomplete="current-password" class="w-full px-3 py-2 border rounded pr-10" required />
            <button type="button" @click="showPassword = !showPassword"
              class="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600">
              <svg v-if="showPassword" class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path
                  d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.42-.08.65 0 1.66 1.34 3 3 3 .23 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" />
              </svg>
              <svg v-else class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
            </button>
          </div>
        </div>
        <button type="submit" class="w-full bg-indigo-600 text-white py-2 rounded hover:bg-indigo-700">Login</button>
        <div v-if="error" class="text-red-500 mt-2 text-center">
          {{ error }}
        </div>
      </form>
    </div>
    <p class="text-center text-sm text-gray-500 mt-4">Versione {{ appVersion }} - Made with ❤️ by Fulcri srl</p>
  </div>
</template>

<script>
/* global __APP_VERSION__ */
import { ref } from 'vue'
import { useFormStore } from '../stores/formStore'

export default {
  name: 'LoginComponent',
  setup() {
    const store = useFormStore()
    store.checkSession()
    const username = ref('')
    const password = ref('')
    const showPassword = ref(false)
    const error = ref('')
    const appVersion = __APP_VERSION__

    const handleLogin = async () => {
      error.value = ''

      if (!username.value || !password.value) {
        error.value = 'Compila tutti i campi.'
        return
      }

      try {
        await store.login(username.value, password.value)
        if (!store.user || !store.isAuthenticated) {
          throw new Error('Errore interno: stato autenticazione non aggiornato')
        }
        store.navigate(store.getHomeRoute())
      } catch (err) {
        console.error('Errore login completo:', err)
        if (err.response?.data?.error) {
          error.value = err.response.data.error
        } else {
          error.value = err.message || 'Errore di connessione o server.'
        }
      }
    }
    return {
      store,
      username,
      password,
      showPassword,
      error,
      appVersion,
      handleLogin,
    }
  },
}
</script>
